import { render, staticRenderFns } from "./Beneficiarios.vue?vue&type=template&id=79a48055&scoped=true&lang=html&"
import script from "./Beneficiarios.vue?vue&type=script&lang=js&"
export * from "./Beneficiarios.vue?vue&type=script&lang=js&"
import style0 from "./Beneficiarios.vue?vue&type=style&index=0&id=79a48055&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a48055",
  null
  
)

export default component.exports